import { QuizQuestion } from '../types';

// 防溺水知识线上测试题库
export const SAFETY_QUIZ: QuizQuestion[] = [
  {
    id: 1,
    question: '遇到同伴或他人落水时，未受过专业救生训练的青少年正确的做法是？',
    options: [
      '立即纵身跳入水中伸手救援',
      '大声呼救寻求成年人帮助，并寻找竹竿、救生圈或救生衣抛给落水者',
      '手拉手结成“人链”下水救人',
      '独自默默离开以免被批评'
    ],
    correctIndex: 1,
    explanation: '未受过救生训练者切勿盲目下水或拉手救援！大声呼救并借助岸上延伸物（竹竿、绳索、救生圈）是安全救助原则。'
  },
  {
    id: 2,
    question: '教育部推广的防溺水“六不准”原则中，关于水域选择的要求是？',
    options: [
      '可以在熟悉的山塘、水库浅水区游泳',
      '只要天气热，任何有水的地方都可以游泳',
      '不准到无安全设施、无救生人员的水域游泳',
      '只要带了游泳圈就可以去河里游'
    ],
    correctIndex: 2,
    explanation: '野外水域水况复杂、水温差异大且极易淤泥缠脚，必须选择有正规救生员与防护设施的场馆。'
  },
  {
    id: 3,
    question: '如果在游泳池中发生小腿抽筋，正确的现场自救姿势是？',
    options: [
      '拼命用力乱蹬腿',
      '深吸气后保持浮姿，一手按膝一手抓住脚趾向上反向拉伸',
      '立即收缩双腿憋气沉到底部',
      '大声尖叫并连续拍打水面'
    ],
    correctIndex: 1,
    explanation: '小腿痉挛时，通过反向拉伸小腿腓肠肌（抓脚趾拉向身体）可快速解除抽筋，并向救生员示意。'
  },
  {
    id: 4,
    question: '关于溺水者救上岸后的CPR心肺复苏，第一步最关键的操作是？',
    options: [
      '先倒水（按压肚皮倒水）',
      '清理口鼻异物并先给予5次有效人工呼吸（因缺氧导致）',
      '直接用力击打患者背部',
      '给患者喂温开水'
    ],
    correctIndex: 1,
    explanation: '传统“控水/倒水”会延误救治时间甚至导致胃内容物反流误吸。应立即清除异物并进行人工呼吸与胸外按压。'
  }
];
